import { render, staticRenderFns } from "./signaturepad.vue?vue&type=template&id=5c8a81aa&scoped=true"
import script from "./signaturepad.vue?vue&type=script&lang=js"
export * from "./signaturepad.vue?vue&type=script&lang=js"
import style0 from "./signaturepad.vue?vue&type=style&index=0&id=5c8a81aa&prod&lang=css"
import style1 from "./signaturepad.vue?vue&type=style&index=1&id=5c8a81aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a81aa",
  null
  
)

export default component.exports